export default __webpack_public_path__ + "static/media/Background_00054.b217362d.png";